module.exports = __webpack_public_path__ + "img/A10.8b693401.svg";